/**
 * TermsCheckbox - "I have read and agree to..."
 * ---------------------------------------------
 * Shown on both signup forms. The account cannot be created until it is
 * ticked, and the moment plus the version are recorded against the account.
 *
 * WHY A TICKBOX RATHER THAN A LINE OF SMALL PRINT
 * A sentence saying "by signing up you agree" relies on the person having
 * noticed it. A box they have to tick is a deliberate act, which is what
 * makes the terms actually hold - and it gives you a record to point at.
 *
 * THE TWO LINKS NO LONGER OPEN A NEW TAB (24 August 2026).
 * They used to, and the hint underneath promised that meant nothing typed
 * would be lost. On a phone that promise was false: a site added to the home
 * screen has no tabs to open, so "new tab" became "leave the form", and the
 * signup was gone. The site was breaking its own promise on exactly the two
 * links it most wants people to follow.
 *
 * Now they are ordinary links, and what keeps the work safe is that the form
 * saves itself as it is typed - see utils/draft.js. The back arrow on the
 * terms page comes straight back to a form with everything still in it, on
 * a phone and on a desktop alike, and the same is true of the browser's own
 * back button and the links in the footer.
 */

import { Link } from 'react-router-dom';

import { useI18n } from '../hooks/useI18n';

export default function TermsCheckbox({ checked, onChange, error }) {
  const { t } = useI18n();
  return (
    <div className="field">
      <label
        htmlFor="acceptedTerms"
        className="row"
        style={{ gap: 'var(--space-xs)', alignItems: 'flex-start', cursor: 'pointer' }}
      >
        <input
          id="acceptedTerms"
          name="acceptedTerms"
          type="checkbox"
          checked={checked}
          onChange={(event) => onChange(event.target.checked)}
          aria-invalid={Boolean(error)}
          required
          className="terms-tickbox"
        />
        <span style={{ fontWeight: 'var(--weight-regular)', color: 'var(--color-text)' }}>
          {t('terms.agree')}{' '}
          <Link to="/terms">{t('terms.termsLink')}</Link>{' '}
          {t('terms.and')}{' '}
          <Link to="/privacy">{t('terms.privacyLink')}</Link>
          . *
        </span>
      </label>

      {error && <span className="field-error">{error}</span>}

      <span className="hint">
        {t('terms.keptWhileReading')}
      </span>
    </div>
  );
}
